import { withPrefix } from "gatsby"

import RichText from "@components/rich-text/renderer"
import { Button as ConsistentlyButton } from "@fastly/consistently"
import { MikanSpan } from "@components/Mikan"
import styled, { css } from "styled-components"

const StyledGlobalNetwork = styled.section`
  width: 100%;
  padding: 0 1rem;
  background: url("/g-static/background/network-worldMap.svg") white 47% 50% no-repeat;
  margin-bottom: ${(props) => props.margBtm && props.margBtm.sm};
  margin-top: ${(props) => props.margTop && props.margTop.sm};

  @media (min-width: 768px) {
    min-height: ${(props) => props.size && props.size.minHeight.md};
    display: flex;
    justify-content: center;
    align-items: center;
  }
`
const StyledGlobalNetworkContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;

  @media (min-width: 1024px) {
    width: 86%;
  }

  @media (min-width: 1440px) {
    width: 75%;
  }

  ${({ className }) =>
    className === "ecp-global-network-map" &&
    css`
      div:first-of-type > p {
        @media (min-width: 768px) {
          width: 40%;
        }

        @media (min-width: 1200px) {
          width: 45%;
        }
      }
    `}
`
const StyledGlobalNetworkIntro = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  text-align: center;

  h2 {
    padding-top: 1rem;
  }

  p {
    line-height: 140%;
    letter-spacing: -0.144px;
    color: var(--grey-70);
    text-align: center;
    margin-bottom: 41px;

    @media (min-width: 768px) {
      width: 64%;
    }

    @media (min-width: 1440px) {
      width: 60%;
    }
  }
`
const StyledBoxPropValuesList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-around;
  gap: var(--size-space-sm);

  @media (min-width: 768px) {
    width: 85%;
    max-width: 728px;
    justify-content: center;
    gap: var(--size-space-md);
  }

  @media (min-width: 1024px) {
    max-width: 100%;
    gap: var(--size-space-xl);
  }
`

const StyledBoxPropValues = styled.span`
  p {
    &:first-of-type {
      background: var(--white);
      box-shadow: 0px 16px 48px rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      font-size: 29px;
      font-weight: 800;
      color: var(--red);
      margin-bottom: 0;
      padding: var(--size-space-md);

      @media (min-width: 768px) {
        font-size: var(--font-size-xl);
      }

      @media (min-width: 1024px) {
        font-size: var(--font-size-2xl);
      }

      sup {
        font-size: var(--font-size-md);
      }
    }

    &:nth-of-type(2) {
      font-weight: 500;
      font: var(--text-sm);
      color: var(--grey-60);
      text-align: center;
    }
  }

  p:nth-of-type(2) {
    margin-top: var(--size-space-xs);
  }
`
const StyledBoxCta = styled.div`
  margin: var(--size-space-md);

  a {
    font-weight: 600;
    text-decoration: none !important;
    padding-right: 16px !important;

    &:before {
      right: -18px;
      top: 0;
    }
  }
`

const GlobalNetwork = ({ title, text, values, cta, className, margBtm, margTop, size }) => {
  return (
    <StyledGlobalNetwork margBtm={margBtm} margTop={margTop} size={size}>
      <StyledGlobalNetworkContent className={className}>
        <StyledGlobalNetworkIntro>
          <h2>{<MikanSpan text={title} />}</h2>
          <RichText body={text.rtContent} key={text.contentful_id} mikan={text.mikan} />
        </StyledGlobalNetworkIntro>

        <StyledBoxPropValuesList>
          {values.map((listItems) => (
            <StyledBoxPropValues classNanme={listItems.name} key={listItems.contentful_id}>
              {listItems.section_content.map((item) => (
                <RichText body={item.rtContent} key={item.contentful_id} mikan={item.mikan} />
              ))}
            </StyledBoxPropValues>
          ))}
        </StyledBoxPropValuesList>
        <StyledBoxCta>
          <ConsistentlyButton variant={cta.variant} url={withPrefix(cta.url)} icon="arrow">
            <MikanSpan text={cta.buttonText} />
          </ConsistentlyButton>
        </StyledBoxCta>
      </StyledGlobalNetworkContent>
    </StyledGlobalNetwork>
  )
}

export default GlobalNetwork
